import React from 'react'

function ForYou() {
  return (
    <div>
     FOR YOU 
    </div>
  )
}

export default ForYou
